import React, { useState } from 'react'
import './ToolKit.scss'
import { ReactComponent as ToolKitIcon01 } from '../assets/svg/toolkit/01.svg'
import { ReactComponent as ToolKitIcon02 } from '../assets/svg/toolkit/02.svg'
import { ReactComponent as ToolKitIcon03 } from '../assets/svg/toolkit/03.svg'
import { ReactComponent as ToolKitIcon04 } from '../assets/svg/toolkit/04.svg'
import { ReactComponent as ToolKitIcon05 } from '../assets/svg/toolkit/05.svg'
import { ReactComponent as ToolKitIcon06 } from '../assets/svg/toolkit/06.svg'
import { ReactComponent as ToolKitIcon07 } from '../assets/svg/toolkit/07.svg'
import { ReactComponent as ToolKitIcon08 } from '../assets/svg/toolkit/08.svg'
import { ReactComponent as ToolKitIcon09 } from '../assets/svg/toolkit/09.svg'
import { ReactComponent as ToolKitIcon10 } from '../assets/svg/toolkit/10.svg'
import { ReactComponent as ToolKitIcon11 } from '../assets/svg/toolkit/11.svg'
import { ReactComponent as ToolKitIcon12 } from '../assets/svg/toolkit/12.svg'
import { ReactComponent as ToolKitIcon13 } from '../assets/svg/toolkit/13.svg'
import { ReactComponent as ToolKitIcon14 } from '../assets/svg/toolkit/14.svg'
import { ReactComponent as ToolKitIcon15 } from '../assets/svg/toolkit/15.svg'
import { ReactComponent as ToolKitIcon16 } from '../assets/svg/toolkit/16.svg'
import { ReactComponent as ToolKitIcon17 } from '../assets/svg/toolkit/17.svg'
import { ReactComponent as ToolKitIcon18 } from '../assets/svg/toolkit/18.svg'
import { ReactComponent as ToolKitCrossIcon } from '../assets/svg/toolkit/cross.svg'

import { useSelector, useDispatch } from 'react-redux'
import { toolKitClicked } from '../redux/actions/index'

function ToolKit() {
    const toolKit = useSelector((state) => state.toolKit)
    const dispatch = useDispatch()
    const toolKitClickeD = () => {
        dispatch(toolKitClicked())
    }
    const [toolKitShow, setToolKitShow] = useState(true)

    return toolKitShow ? (
        <div
            className="ToolKit"
            style={{ top: `${toolKit.top}px`, right: `${toolKit.right}px` }}
            onMouseDown={() => toolKitClickeD()}
        >
            <ToolKitIcon01 />
            <ToolKitIcon02 />
            <ToolKitIcon03 />
            <ToolKitIcon04 />
            <ToolKitIcon05 />
            <ToolKitIcon06 />
            <ToolKitIcon07 />
            <ToolKitIcon08 />
            <ToolKitIcon09 />
            <ToolKitIcon10 />
            <ToolKitIcon11 />
            <ToolKitIcon12 />
            <ToolKitIcon13 />
            <ToolKitIcon14 />
            <ToolKitIcon15 />
            <ToolKitIcon16 />
            <ToolKitIcon17 />
            <ToolKitIcon18 />
            <ToolKitCrossIcon onClick={() => setToolKitShow(false)} />
        </div>
    ) : (
        <></>
    )
}

export default ToolKit
